function validate(binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
        const componentName = vNode.context.name;
        let warn = `[Vue-click-outside] Provided expression '${binding.expression}' is not a function, but has to be.`;

        if (componentName) {
            warn += ` Found in component '${componentName}'`;
        }

        // eslint-disable-next-line no-console
        console.warn(warn);
        return false;
    }

    return true;
}

export default () => {
    return {
        bind(el, binding, vNode) {
            if (!validate(binding, vNode)) {
                return;
            }

            // Define Handler and cache it on the element
            const bubble = binding.modifiers.bubble;
            const handler = (e) => {
                if (bubble || (!el.contains(e.target) && el !== e.target)) {
                    binding.value(e);
                }
            };

            el.__vueClickOutside__ = handler;

            const clickHandler = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
            document.addEventListener(clickHandler, handler);
        },

        unbind(el) {
            const clickHandler = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';
            document.removeEventListener(clickHandler, el.__vueClickOutside__);
            delete el.__vueClickOutside__;
        },
    };
};
